import React from 'react';
import LoadingImg from '../components/img/Loading.gif';

const Loading = () => {
  return (
    <div className='w-full h-[100vh] flex-1 dark:bg-blackbg flex justify-center items-center'>
      <img className='w-48' src={LoadingImg}></img>
    </div>
  );
};

export default Loading;
